
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type garageListDialogRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function garageListDialogRT(): TemplateResult<garageListDialogRTRootProps> {
    return _createElement('div', { 'className': 'dialog-container' }, _createElement('div', { 'className': 'dialog-content' }, _createElement('div', { 'className': 'dialog-header' }, _createElement('div', { 'className': 'dialog-title-container' }, _createElement('div', { 'className': 'dialog-title' }, 'Your Saved Vehicles'), _createElement('div', {
        'className': 'close',
        'onClick': this.close
    }, _createElement('svg', {
        'className': 'cm_icon cm_icon-times',
        'height': '20px',
        'role': 'img',
        'viewBox': '0 0 22 22'
    }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))))), _createElement('div', {
        'className': 'cm_Garage_tab',
        'onClick': this.close
    }, [this.GarageListDialogContent(function () {
            function repeatItems1(items, itemsIndex) {
                return [items(function () {
                        return _createElement('div', {
                            'className': 'garage-item form-check',
                            'onClick': this.selectVehicle
                        }, _createElement('input', {
                            'type': 'radio',
                            'className': 'form-check-input',
                            'readOnly': true,
                            'checked': this.isSelected
                        }), _createElement('label', { 'className': 'select-model form-check-label' }, _createElement('div', { 'className': 'select-model_title' }, '\n                      ', window.Convermax.getVehicleLabelWithoutDifferential(this.vehicle), '\n                    '), this.vehicle.Differential ? _createElement('div', {
                            'className': 'select-model_differnetial',
                            'key': '444'
                        }, '\n                      ', this.vehicle.Differential, '\n                    ') : null), _createElement('span', {
                            'className': 'remove-model',
                            'onClick': this.removeVehicle
                        }, [_createElement('svg', {
                                'width': '14',
                                'height': '18',
                                'viewBox': '0 0 14 18',
                                'fill': 'none',
                                'xmlns': 'http://www.w3.org/2000/svg',
                                'key': '6980'
                            }, _createElement('path', {
                                'd': 'M4.06641 2.125C4.06641 1.3 4.68582 0.625 5.44288 0.625',
                                'stroke': '#4F4C4D',
                                'strokeWidth': '1.25',
                                'strokeMiterlimit': '10'
                            }), _createElement('path', {
                                'd': 'M8.19727 0.625C8.95432 0.625 9.57374 1.3 9.57374 2.125',
                                'stroke': '#4F4C4D',
                                'strokeWidth': '1.25',
                                'strokeMiterlimit': '10'
                            }), _createElement('path', {
                                'd': 'M9.57229 2.125V3.625H4.06641V2.125',
                                'stroke': '#4F4C4D',
                                'strokeWidth': '1.25',
                                'strokeMiterlimit': '10'
                            }), _createElement('path', {
                                'd': 'M8.1963 0.625H5.44336',
                                'stroke': '#4F4C4D',
                                'strokeWidth': '1.25',
                                'strokeMiterlimit': '10'
                            }), _createElement('path', {
                                'd': 'M0.625 3.625H13.0132',
                                'stroke': '#4F4C4D',
                                'strokeWidth': '1.25',
                                'strokeLinecap': 'round',
                                'strokeLinejoin': 'round'
                            }), _createElement('path', {
                                'd': 'M11.6372 6.625H2.00195V17.125H11.6372V6.625Z',
                                'stroke': '#666768',
                                'strokeWidth': '1.25',
                                'strokeLinecap': 'round',
                                'strokeLinejoin': 'round'
                            }), _createElement('path', {
                                'd': 'M5.44336 9.625V14.125',
                                'stroke': '#666768',
                                'strokeWidth': '1.25',
                                'strokeLinecap': 'round',
                                'strokeLinejoin': 'round'
                            }), _createElement('path', {
                                'd': 'M8.19727 9.625V14.125',
                                'stroke': '#666768',
                                'strokeWidth': '1.25',
                                'strokeLinecap': 'round',
                                'strokeLinejoin': 'round'
                            }))]));
                    }, { count: undefined })];
            }
            return _createElement('div', { 'className': 'cm_garage cm_garage__dialog-list cm_GarageListDialogContent' }, _createElement('div', { 'className': 'cm_garageDropdown' }, !this.isEmpty ? _createElement('div', {
                'className': 'cmTemplate_list',
                'key': '124'
            }, _createElement('div', { 'className': 'vehical_title' }, _createElement('span', {}, 'Search parts for:')), _createElement('div', { 'className': 'garage-content' }, _createElement.apply(this, [
                'div',
                { 'className': 'cmRepeater_items' },
                _map(this.items, repeatItems1.bind(this))
            ])), _createElement('div', { 'className': 'garage-buttons' }, _createElement('div', {
                'className': 'add-vehicle btn-sm btn btn-primary',
                'onClick': () => setTimeout(() => window.Convermax.openGarageDialog('cm_vehicle-search'), 100)
            }, [window.Convermax.config?.garageButtonText || _translate(`garage_add_button`)]), _createElement('div', {
                'className': 'discard-vehicle',
                'onClick': this.discardVehicle,
                'role': 'button',
                'tabIndex': '0'
            }, '\n                Shop Without Vehicle\n              '))) : null, this.isEmpty ? _createElement('div', {
                'className': 'cmTemplate_empty',
                'key': '4407'
            }, _createElement('div', { 'className': 'garage-content' }, _createElement('ul', {}, _createElement('li', { 'className': 'vehicle-advantages' }, _translate(`garage_info_line_one`)), _createElement('li', { 'className': 'vehicle-advantages' }, _translate(`garage_info_line_two`)), _createElement('li', { 'className': 'vehicle-advantages' }, _translate(`garage_info_line_three`))), _createElement('div', {
                'className': 'add-vehicle btn-sm btn btn-primary',
                'onClick': () => setTimeout(() => window.Convermax.openGarageDialog('cm_vehicle-search'), 100)
            }, [window.Convermax.config?.garageButtonText || _translate(`garage_add_button`)]))) : null));
        }, {
            widgetName: 'undefined',
            items: undefined
        })])));
}
        export const componentNames = ["cm:GarageListDialogContent"]